







































































import Vue from 'vue';
import { Utils } from '@/Utils';
import axios from 'axios';
import { WebhookEndpoint, Campaign } from '@/types';
import AddWebhookDialog from './AddWebhookDialog.vue';

declare const $: any;

interface Data {
    webhooks: WebhookEndpoint[];
    campaigns: Campaign[];
}

export default Vue.extend({
    components: {
        AddWebhookDialog,
    },
    data: function(): Data {
        return {
            webhooks: [],
            campaigns: []
        };
    },
    created: function() {
        const webhooksReq = axios
            .get(`${process.env.VUE_APP_API_URI}/api/admin/webhooks`)
            .then(res => {
                if (res.status !== 200) {
                    Utils.toastError('Unable to fetch webhooks');
                } else {
                    this.webhooks = res.data;
                }
            });
        const campaignsReq = axios
            .get(`${process.env.VUE_APP_API_URI}/api/admin/weblinks`)
            .then(res => {
                if (res.status !== 200) {
                    Utils.toastError('Unable to fetch campaigns');
                } else {
                    this.campaigns = res.data;
                }
            });
    },
    methods: {
        disableWebhook(webhook: WebhookEndpoint) {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/webhooks/${webhook.id}/disable`)
                .then(res => {
                    webhook.active = false;
                    Utils.toastSuccess('Webhook Endpoint Disabled');
                })
                .catch(err => {
                    console.error(err);
                    Utils.toastError('Failed to disable webhook endpoint');
                });
        },

        enableWebhook(webhook: WebhookEndpoint) {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/webhooks/${webhook.id}/enable`)
                .then(res => {
                    webhook.active = true;
                    Utils.toastSuccess('Webhook Endpoint Enabled');
                })
                .catch(err => {
                    console.error(err);
                    Utils.toastError('Failed to enable webhook endpoint');
                });
        },

        addWebhook() {
            let campaigns = this.$data.campaigns;

            // Callback will allow us to refresh our list of webhooks once the new one has been successfully added.
            let callback = (newWebhook) => {
                this.$data.webhooks.push(newWebhook);
            };

            this.$modal.show('add-webhook-dialog', {
                campaigns, callback
            });
        },

        deleteWebhook(webhook: WebhookEndpoint) {
            axios
                .post(`${process.env.VUE_APP_API_URI}/api/admin/webhooks/${webhook.id}/delete`)
                .then(res => {
                    
                    this.$data.webhooks = this.$data.webhooks.filter(e => e !== webhook);

                    Utils.toastSuccess('Webhook Endpoint Deleted');
                })
                .catch(err => {
                    console.error(err);
                    Utils.toastError('Failed to delete webhook endpoint');
                });
        }
    },
});
